export default "/images/2b9ede1bebb2b27d2bbf14f39038b6f2.avif";